export default "__VITE_ASSET__DfIXfvfC__"